import React from 'react';
import Button from "@/components/common/buttons/Button";
import ButtonGroup from "@/components/common/buttons/ButtonGroup";

const ErrorState = ({data, onTryAgain=()=>null, onStartOver=()=>null, onQuit=()=>null}) => {
	return (
		<div className={'flex flex-col gap-4 items-center justify-center flex-grow w-full xl:max-w-[1040px] lg:max-w-[960px] max-w-[650px]'}>
			<div className={'flex flex-col gap-4 w-full text-primary bg-white bg-opacity-50 rounded-lg p-4'}>
				{ data.code ? 
				<h1 className={'font-gBold text-3xl'}>Sorry, we can&#39;t process your request right now. Please try again later.</h1>
				 : 
				 <>
				 <h1 className={'font-gBold text-3xl'}>UH OH!?</h1>
				 <div className={''}>
					 <p>It looks like our AI is having a hard time with that one.</p>
					 <p className={'font-gBold text-lg'}>What would you like to do?</p>
					 <p>You can...</p>
					 <ul className={'list-disc list-inside'}>
						 <li>Try again to attempt to continue this run</li>
						 <li>Start over to enter a different topic</li>
						 <li>Quit to go home</li>
					 </ul>
				 </div>
				 </>
				 }
				
			</div>
			<ButtonGroup
				primaryLabel={'Try Again'}
				primaryAction={onTryAgain}
				secondaryAction={onStartOver}
				secondaryLabel={'Start Over'}
				tertiaryAction={onQuit}
			/>
		</div>
	);
};

export default ErrorState;
